import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { requireAppCheck } from '@jfw/angular/shared/app-check';
import { PLATFORM_DP_ENVIRONMENT } from '@jfw/angular/shared/tokens';
import { EzTuxAccountBalance } from '@jfw/types';
import { catchError, map, Observable, of } from 'rxjs';

type AccountBalanceResult = {
  success: boolean;
  data: EzTuxAccountBalance | undefined;
};

@Injectable({
  providedIn: 'root',
})
export class WholesaleAccountBalanceService {
  private readonly http = inject(HttpClient);
  private readonly environment = inject(PLATFORM_DP_ENVIRONMENT);
  private readonly accountBalanceApiUrl =
    this.environment.account_balance_api_server_url;

  public getAccountBalance(
    accountNumber: string,
  ): Observable<AccountBalanceResult> {
    return this.http
      .get<EzTuxAccountBalance>(`${this.accountBalanceApiUrl}/${accountNumber}`, {
        ...requireAppCheck,
      })
      .pipe(
        map((data) => ({
          success: true,
          data,
        })),
        catchError((error) => {
          console.error(error);
          return of({ success: false, data: undefined });
        }),
      );
  }
}
